var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntryBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0.5,
    cy: 0.5,
    r: 0.775,
    gradientTransform: "matrix(.512 0 0 1 .244 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#775cee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#2d318b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#363697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#4d43b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#5f4ecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#6c56e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#745aea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#775cee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#654ecb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#2f245f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#0d0a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2",
    cx: 760.091,
    cy: 395.115,
    rx: 760.091,
    ry: 395.115,
    transform: "translate(199.909 145.135)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    fill: "#040000",
    d: "M0 0h1920v1080H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2",
    clipPath: "url(#a)",
    transform: "translate(0 -.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 1",
    cx: 771.12,
    cy: 395.115,
    rx: 771.12,
    ry: 395.115,
    transform: "translate(188.88 145.135)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    d: "M960 145.135v790.23"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    d: "m905.907 146.103 108.185 788.294"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3",
    d: "m852.08 149.002 215.84 782.496"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 4",
    d: "m798.781 153.818 322.438 772.863"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 5",
    d: "m746.272 160.528 427.456 759.444"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6",
    d: "m694.81 169.098 530.379 742.304"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7",
    d: "m644.648 179.486 630.704 721.527"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8",
    d: "m596.031 191.642 727.939 697.215"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 9",
    d: "m549.197 205.507 821.607 669.487"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 10",
    d: "m504.376 221.011 911.249 638.478"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 11",
    d: "m461.787 238.079 996.426 604.341"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 12",
    d: "m421.639 256.629 1076.722 567.243"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 13",
    d: "M384.129 276.567 1535.87 803.933"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 14",
    d: "m349.441 297.798 1221.118 484.904"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 15",
    d: "m317.744 320.216 1284.512 440.067"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 16",
    d: "m289.194 343.713 1341.612 393.074"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 17",
    d: "m263.931 368.173 1392.138 344.155"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 18",
    d: "m242.078 393.475 1435.844 293.549"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 19",
    d: "m223.743 419.497 1472.514 241.506"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 20",
    d: "m209.015 446.111 1501.97 188.279"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 21",
    d: "m197.967 473.185 1524.066 134.129"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 22",
    d: "m190.652 500.589 1538.695 79.322"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 23",
    d: "m187.107 528.186 1545.785 24.127"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    d: "m187.349 555.844 1545.301-31.187"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    d: "m191.377 583.423 1537.246-86.347"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    d: "M199.171 610.793 1720.83 469.708"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    d: "m210.692 637.815 1498.616-195.131"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 28",
    d: "m225.885 664.361 1468.23-248.222"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 29",
    d: "m244.674 690.298 1430.651-300.096"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 30",
    d: "M266.969 715.5 1653.031 365"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 31",
    d: "m292.659 739.843 1334.682-399.186"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 32",
    d: "m321.619 763.209 1276.762-445.917"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 33",
    d: "m353.707 785.482 1212.587-490.463"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 34",
    d: "m388.765 806.552 1142.47-532.605"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 35",
    d: "m426.622 826.319 1066.756-572.138"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 36",
    d: "m467.093 844.684 985.815-608.868"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 37",
    d: "m509.978 861.558 900.043-642.615"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 38",
    d: "m555.069 876.857 809.862-673.213"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 39",
    d: "m602.144 890.506 715.713-700.512"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 40",
    d: "m650.972 902.439 618.057-724.379"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 41",
    d: "m701.314 912.598 517.373-744.697"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 42",
    d: "m752.923 920.933 414.154-761.366"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 43",
    d: "m805.547 927.402 308.905-774.305"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 44",
    d: "m858.928 931.975 202.143-783.45"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 45",
    d: "m912.805 934.629 94.391-788.757"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryBg);
export default __webpack_public_path__ + "static/media/entry_bg.74313a53.svg";
export { ForwardRef as ReactComponent };